<template>
  <div :v-if="isInRole(['admin', 'support','analyst'])">
    <toolbar/>
    <zlick-navigation />

    <v-container fluid text-xs-center>
      <v-dialog v-model="dialog" max-width="500px">
        <v-form ref="refundReasonForm" lazy-validation>
          <v-card>
            <v-card-text>
              <v-flex xs12 offset-xs0>
                <h3>{{$t('refundDialogInfo')}}</h3>
                <br>
                <v-text-field
                  v-model="refundReason"
                  validate-on-blur
                  :rules="[v => !!v || $t('refundReason_required')]"
                  required>
                </v-text-field>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="close">{{$t('cancel')}}</v-btn>
              <v-btn color="blue darken-1" flat @click.native="deleteItem">{{$t('refund')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-container>

    <v-container v-if="!error" fluid text-xs-center>
    <v-layout row wrap center>
      <v-flex xs12 offset-xs0>
        <v-data-table
          :headers="headers"
          :items="items"
          :pagination.sync="pagination"
          :total-items="getTotalItems"
          hide-actions
          class="elevation-1">
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item._id }}</td>
            <td class="text-xs-center">{{ formatDate(props.item.createdAt) }}</td>
            <td class="text-xs-center">{{ props.item.phone }}</td>
            <td class="text-xs-center">{{ props.item.content }}</td>
            <td class="text-xs-center">{{ formatProductData(props.item.productData, 'referenceName', 'name') }}</td>
            <td class="text-xs-center">{{ props.item.type }}</td>
            <td class="text-xs-center">{{ formatProductData(props.item.productData, 'periodLenght') }}</td>
            <td class="text-xs-center">{{ (props.item.amount / 100).toLocaleString().replace('.', ',') }}</td>
            <td class="text-xs-center">{{ formatAmount(props.item.serviceFee) }}</td>
            <td class="text-xs-center">{{ formatAmount(props.item.grossAmount) }}</td>
            <td class="text-xs-center">{{ formatAgent(props.item) }}</td>
            <td class="text-xs-center">{{ props.item.clientUserId }}</td>
            <td class="text-xs-bottom" v-if="!isAnalyst()" >
              <v-btn icon class="mx-0" v-if="(refund(props.item) === 'refund') && !props.item.refundDisabled">
                <v-icon @click="showDeleteBox(props.item)" color="pink">delete</v-icon>
              </v-btn>
              <p v-if="refund(props.item) === 'refunded'" class="text-xs-center">{{ props.item.refundReason }}</p>
              <p v-if="refund(props.item) === 'alreadyRefunded'" class="text-xs-center">{{$t('alreadyRefunded')}}</p>
              <p v-if="refund(props.item) === 'failed'" class="text-xs-center">{{$t('refundFailed')}}</p>
              <div v-if="refund(props.item) === 'manualRefund'" class="text-xs-center">
                <v-btn icon class="mx-0" v-if="!props.item.refundDisabled">
                  <v-icon @click="showDeleteBox(props.item)" color="pink">delete</v-icon>
                </v-btn>
              </div>
            </td>
          </template>

          <template slot="no-data">
            <v-btn color="primary" @click="initialize">{{$t('reload')}}</v-btn>
          </template>
        </v-data-table>
      </v-flex>
      </v-layout>
    </v-container>

    <v-container v-if="!error" fluid text-xs-center>
    <v-layout row wrap center>
      <v-flex xs12 offset-xs0>
      <v-pagination
        v-model="pagination.page"
        :length="pagesCount"
        @input="newPage(pagination.page)"
      />
      </v-flex>
    </v-layout>
    </v-container>

    <v-container v-if="error" grid-list-md>
      <v-layout row wrap center>
        <v-flex xs12 offset-xs4>
          <v-text-field color="error" v-text="error"/>
        </v-flex>
      </v-layout>
    </v-container>

  </div>
</template>

<script>

import Toolbar from './Toolbar'
import ZlickNavigation from './ZlickNavigation'
import TransactionService from '../services/TransactionsService'
import moment from 'moment'
import AuthenticationService from '../services/AuthenticationService'
import Bugsnag from '../services/Bugsnag'
import { mapState } from 'vuex'

export default {
  components: {
    Toolbar,
    ZlickNavigation
  },
  data: function () {
    return {
      dialog: false,
      refundReason: '',
      itemToDelete: ''
    }
  },

  beforeCreate () {
    if (!AuthenticationService.isUserLoggedIn()) {
      this.$router.push('/login')
      return
    }
    if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) {
      this.$router.push('/telemarketing')
    }
  },

  created () {
    this.initialize()
  },

  computed: {

    ...mapState({
      activeCognitoGroup: state => state.user.activeCognitoGroup
    }),

    headers () {
      const baseHeaders = [
        { text: this.$t('transactionId'), value: '_id', align: 'center' },
        { text: this.$t('createdAt'), value: 'createdAt', align: 'center' },
        { text: this.$t('phone_number'), value: 'phone', align: 'center' },
        { text: this.$t('referenceNumber'), value: 'content', align: 'center' },
        { text: this.$t('productName'), value: 'productName', align: 'center' },
        { text: this.$t('transactionType'), value: 'type', align: 'center' },
        { text: this.$t('period'), value: 'periodLenght', align: 'center' },
        { text: this.$t('amount'), value: 'amount', align: 'center' },
        { text: this.$t('additionalFee'), value: 'serviceFee', align: 'center' },
        { text: this.$t('chargedAmount'), value: 'grossAmount', align: 'center' },
        { text: this.$t('user'), value: 'agent', align: 'center' },
        { text: this.$t('clientUserId'), value: 'clientUserId', align: 'center' }
      ]
      if (!this.isAnalyst()) {
        baseHeaders.push({ text: this.$t('refundReason'), value: 'name', sortable: false, align: 'center' })
      }
      return baseHeaders
    },

    items: {
      get: function () {
        return this.$store.state.transactions.docs
      },
      set: function (newValue) {
        this.$store.commit('setTransactions', newValue)
      }
    },
    pagination: {
      get: function () {
        return this.$store.state.pagination
      },
      set: function (newValue) {
        this.$store.commit('setPagination', newValue)
      }
    },
    getTotalItems () {
      return this.$store.state.transactions.total
    },
    pagesCount () {
      let totalItems = this.$store.state.transactions.total
      if (!totalItems || totalItems === 0) return 0
      return Math.ceil(totalItems / this.pagination.rowsPerPage)
    },
    error: {
      get: function () {
        return this.$store.state.error
      },
      set: function (newValue) {
        this.$store.commit('setError', newValue)
      }
    }
  },
  watch: {

    activeCognitoGroup (newValue, oldValue) {
      console.log(`cognito Updating from ${oldValue} to ${newValue}`)
      this.initialize()
    },

    pagination: {
      handler () {
        this.$store.dispatch('sortTransactions')
      },
      deep: true
    }
  },

  methods: {
    async newPage (page) {
      let searchValue = this.$store.state.searchValue
      let dateRange = this.$store.state.dateRange

      if (!searchValue && this.objectIsEmpty(dateRange)) {
        this.initialize(page)
      } else {
        let searchQuery = {
          searchValue,
          dates: {
            startDate: dateRange.startDate,
            endDate: dateRange.endDate
          }
        }
        let response = await TransactionService.search({searchQuery, page, limit: this.pagination.rowsPerPage})
        this.$store.commit('setTransactions', response.data)
      }
    },
    objectIsEmpty (object) {
      return Object.keys(object).length === 0 && object.constructor === Object
    },
    isAnalyst () {
      return AuthenticationService.isAnalyst()
    },
    isInRole (roles) {
      return AuthenticationService.isInRole(roles)
    },
    async initialize (page = 1, limit = 20) {
      try {
        this.$store.commit('setError', null)
        let response = await TransactionService.search({page, limit})
        this.$store.commit('setTransactions', response.data)
      } catch (error) {
        this.$store.commit('setError', error.message)
        Bugsnag.send(error)
      }
    },

    formatDate (createdAt) {
      return moment(createdAt).format('DD.MM.YYYY HH:mm:ss')
    },

    formatAmount (value) {
      if (value === undefined || value === null) return ''
      return (value / 100).toLocaleString().replace('.', ',')
    },

    formatProductData (productData, fieldName, fieldName2 = undefined) {
      if (!productData) return ''
      try {
        if (productData[fieldName]) {
          return productData[fieldName]
        }
        if (fieldName2 && productData[fieldName2]) {
          return productData[fieldName2]
        }
        // old array format
        if (Array.isArray(productData)) {
          return productData.map(x => x[fieldName]).toString()
        }
        // new object format
        if (productData.product) {
          const filedMap = {
            periodLenght: 'periodLength'
          }
          const field = filedMap[fieldName]
          return productData.product.purchaseItems.map(x => x[field]).toString()
        }
        return ''
      } catch (error) {
        Bugsnag.send(error)
        return ''
      }
    },

    showDeleteBox (item) {
      if (moment().diff(moment(item.createdAt), 'days') > 185) {
        this.$toast.error(this.$t('refundTooOld'))
        return
      }
      this.dialog = true
      this.itemToDelete = item
    },

    async deleteItem () {
      if (!this.$refs.refundReasonForm.validate()) return
      const { _id } = this.itemToDelete
      try {
        await TransactionService.refund({
          refundReason: this.refundReason,
          transactionId: _id
        })
        this.refundReason = ''
        this.itemToDelete = {}
        this.initialize()
      } catch (error) {
        this.initialize()
        Bugsnag.send(error)
      } finally {
        this.close()
      }
    },

    formatAgent (item) {
      if (!item.agent) return ''
      if (item.agent.email) return item.agent.email
      const agentName = item.agent.name.charAt(0).toUpperCase() + item.agent.name.slice(1)
      if (item.agent.familyName) return agentName + ' ' + item.agent.familyName
      return agentName
    },

    refund (item) {
      let transactionType = item.type

      if (item.state === 'failed' && item.type === 'purchase') return 'failed'
      if (item._id === this.itemToDelete._id && this.dialog === false) return 'manualRefund'
      if (transactionType !== 'refund' && item.alreadyRefunded) return 'alreadyRefunded'
      if (transactionType !== 'refund') return 'refund'
      if (transactionType === 'refund') return 'refunded'
    },

    close () {
      this.dialog = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Transactions.vue